import moment from 'moment';
import { cronPlaces } from './constants';
import cronToHuman from 'cronstrue';

export const convertCronExprToUTCMoment = expr => {
  if (!expr || !expr.length) {
    return moment().utc();
  }

  let cronArr = expr.split(' ');
  let hour = cronArr[cronPlaces.HOUR];
  let minute = cronArr[cronPlaces.MIN];
  let second = cronArr[cronPlaces.SEC];

  return moment()
    .utc()
    .set({
      hour,
      minute,
      second
    });
};

export const getUTCTimeObjFromLocalMoment = mom => ({
  raw: mom.utc(),
  hour: mom.utc().format('HH'),
  minute: mom.utc().format('mm'),
  second: mom.utc().format('ss')
});

export const convertUTCCronExprToLocalCronExpr = exp => {
  let expArr = exp.split(' ');
  let utcMoment = convertCronExprToUTCMoment(exp);

  expArr[cronPlaces.HOUR] = utcMoment.local().format('HH');
  expArr[cronPlaces.MIN] = utcMoment.local().format('mm');
  expArr[cronPlaces.SEC] = utcMoment.local().format('ss');
  return expArr.join(' ');
};

export const getHumanReadableCronInLocalTime = exp => {
  if (!exp) return null;
  let localCron = convertUTCCronExprToLocalCronExpr(exp);
  return cronToHuman.toString(localCron);
};
